import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useConfiguration from '../../configuration/use-configuration.js';
import isIframe from '~/utils/iframe-utils.js';
import { selectSiteCode } from '../brand/ducks/index.js';

const IframeSpinner = () => {
	const { isIntegrationTesting } = useConfiguration();
	const location = useLocation();
	const siteCode = useSelector(selectSiteCode);

	if (!isIframe()) return null;

	// Check if parent window has same brand name in url
	// Used for Wordpress sites
	const hasSameReferrer = document.referrer.includes(siteCode);

	const getSpinnerState = () => {
		switch (true) {
			case isIntegrationTesting:
				return false;
			case !hasSameReferrer:
				return true;
			case location?.search?.includes('accHistRef'):
				return true;

			default:
				return false;
		}
	};

	const showSpinner = getSpinnerState();

	if (showSpinner) {
		const { pathname, search } = location;
		const payload = { IframeRedirectUrl: pathname + search };
		window.parent.postMessage(payload, '*');
	}
	return showSpinner ? <div className="iframe-overlay spinner" /> : null;
};

export default IframeSpinner;
